// types
import { CountryCode, Option } from '../../../@types';

// i18n
import { supportedLocales } from '../../../i18n';

// fields
import { Select, SelectProps } from '../Select/Select';

// ui
import { Flag } from '../../ui/Flag/Flag';

// utils
import { translateLanguage } from '../../../utils/translations';

export const SelectLocale = ({ name = 'locale', ...props }: SelectProps) => {
	// options
	const optionsLocales: Option[] = supportedLocales.map((locale) => {
		const localeArray = locale.split('-');
		const languageCode = localeArray[0];

		return {
			icon: <Flag code={localeArray[1] as CountryCode} />,
			label: translateLanguage(languageCode),
			value: locale,
		};
	});

	return <Select hasNoneOption={false} name={name} options={optionsLocales} {...props} />;
};
